export interface BundleServer {
  url: string;
  port: number;
  close: () => Promise<void>;
}
